// Considered: TickSliderAtom — rejected because it is a discrete step-1 control (a tick dot per
// stop) with no `step` prop, and the a2ui `Slider` component contract exposes an arbitrary step.
// This atom is the design-system's single entry point for `primereact/slider` (atomic-design.md
// Rule 2: only the atoms layer may import PrimeReact directly).
import React from 'react';
import { Slider, type SliderChangeEvent } from 'primereact/slider';
import './SliderAtom.scss';

export interface SliderAtomProps {
  value: number;
  min?: number;
  max?: number;
  /** Increment between selectable values. Default 1. */
  step?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
  'data-testid'?: string;
}

const SliderAtom: React.FC<SliderAtomProps> = ({
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  disabled = false,
  ariaLabel,
  className = '',
  'data-testid': testId,
}) => (
  <div className={`slider-atom ${className}`.trim()} data-testid={testId}>
    {/* `aria-label` must live on the slider's own `role="slider"` element — axe's
        `aria-input-field-name` checks the control's own accessible name, not an ancestor's. */}
    <Slider
      value={value}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(event: SliderChangeEvent) => onChange(event.value as number)}
    />
  </div>
);

export default SliderAtom;
